module.exports = __webpack_public_path__ + "img/support_c5.581fa74f.png";